/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { Action, Dispatch } from "redux";
import {
  SHOW_TOAST,
  CLEAR_TOAST,
  SET_SCRINFO,
  SET_PLAYER_STATE,
  GET_DOC,
  GET_DOC_FAIL,
  ApricotActionCreator,
} from "./types";

import axios from "axios";
const inTest = process.env.NODE_ENV === "test";

export const showToast: ApricotActionCreator = (data: ToastType) => async (
  dispatch: Dispatch<any>,
  getState,
  api,
): Promise<Action> => dispatch({ type: SHOW_TOAST, payload: data });

export const clearToast: ApricotActionCreator = () => async (
  dispatch: Dispatch<any>,
  getState,
  api,
): Promise<Action> => dispatch({ type: CLEAR_TOAST });

export const setScreenInfo: ApricotActionCreator = (info) => async (
  dispatch: Dispatch<any>,
  getState,
  api,
): Promise<Action> => dispatch({ type: SET_SCRINFO, payload: info });

export const setPlayerState: ApricotActionCreator = (state) => async (
  dispatch: Dispatch<any>,
  getState,
  api,
): Promise<Action> => dispatch({ type: SET_PLAYER_STATE, payload: state });

export const getDoc: ApricotActionCreator = (type: number) => async (
  dispatch: Dispatch<any>,
  getState,
  api,
): Promise<Action> => {
  // call selector with state and mimic props.match.params.id
  if (inTest) {
    return Promise.resolve() as any;
  }

  try {
    if (type < 0 || type > 3) throw "wrong doc type";

    api = api || axios;
    const { data } = await api.get(`/api/fd/${type}`);

    return dispatch({
      type: GET_DOC,
      payload: { type, data },
    });
  } catch (err) {
    return dispatch({
      type: GET_DOC_FAIL,
      payload: null,
    });
  }
};

export type ToastType = null | { type: "normal" | "warn"; message: string };
export type ApricotAction = ApricotActionCreator;
